// extracted by mini-css-extract-plugin
export default {"Owner":"Owner_Owner__KR+jF","Owner__name":"Owner_Owner__name__XoT1N","Owner__initials":"Owner_Owner__initials__JnjdT"};